module.exports = "https://www.gc-qa.gnp.com.mx/df792970a88baf8c8f30130c9da48429.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/next.png
// module id = 8154
// module chunks = 0